import { Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { HomeService } from '../../../../services/home.service';
import { UserService } from '../../../../services/user';
import { FinancialManagerService } from '../../../../services/financial-manager';
import { ExcelExportService } from '../../../../services/excel-export.service';

import { PaymentData } from '../../../../interfaces/payment';
import { UserInterface } from '../../../../interfaces/user-interface';

@Component({
  selector: 'app-f-m-homepagemobile',
  templateUrl: './f-m-homepagemobile.component.html',
  styleUrl: './f-m-homepagemobile.component.scss'
})
export class FMHomepagemobileComponent {

  allData: PaymentData[] = [];
  allUsers: UserInterface[] = [];

  totalAllOrders: number = 0;
  totalAllDue: number = 0;
  totalCompleted: number = 0;
  totalPending: number = 0;

  stockTotal: number = 0;
  totalItems: number = 0;

  perPage: number = 10;
  page: number = 1;

  contentReady: boolean = true;
  noData: boolean = false;
  showAllUsers: boolean = false;

  accountType!: string;
  isAdmin: boolean = false;
  isSubAdmin: boolean = false;

  userId: any;
  selectedUserId: string | null = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private _FinancialManager: FinancialManagerService,
    private _userService: UserService,
    private _homeService: HomeService,
    private excelExportService: ExcelExportService
  ) {}

  ngOnInit(): void {
    this.getCurrentUserId();

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];

        this.isAdmin = this.accountType === '1' || this.accountType === '10';
        this.isSubAdmin = this.accountType === '6';

        if (this.isAdmin || this.isSubAdmin) {
          this.getAllPaymentsData(this.perPage, 1, true);
          this.getAllUsers();
        } else {
          this._userService.getUserId().subscribe({
            next: (userData) => {
              this.userId = userData['user_id'];
              this.selectedUserId = this.userId;
              this.getUserPayment(this.userId, 1, true);
            },
            error: (error) => {
              console.error(error);
              this.contentReady = false;
            }
          });
        }
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  getCurrentUserId(): void {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.userId = data['user_id'];
      },
      error: (error) => console.error(error)
    });
  }

  getAllPaymentsData(perpage: number = this.perPage, page: number = 1, resetPaginator: boolean = false): void {
    this.contentReady = true;
    this.showAllUsers = false;

    this._FinancialManager.getPayments(perpage, page).subscribe({
      next: (data: any) => {
        this.page = page;
        this.applyPaymentResponse(data, resetPaginator);
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  getUserPayment(id: string, page: number = 1, resetPaginator: boolean = false): void {
    this.contentReady = true;
    this.showAllUsers = false;
    this.selectedUserId = id;

    this._FinancialManager.getUserPayement(id, page).subscribe({
      next: (data: any) => {
        this.page = page;
        this.applyPaymentResponse(data, resetPaginator);
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  applyPaymentResponse(data: any, resetPaginator: boolean = false): void {
    this.allData = data?.data || [];

    this.stockTotal = Number(data?.total || 0);
    this.totalItems = Number(data?.last_page || 0);

    this.totalAllOrders = Number(data?.total_all_orders || 0);
    this.totalAllDue = Number(data?.total_all_due || 0);
    this.totalCompleted = Number(data?.total_completed || 0);
    this.totalPending = Number(data?.total_pending || 0);

    this.noData = this.allData.length === 0;
    this.contentReady = false;

    if (resetPaginator && this.paginator) {
      setTimeout(() => this.paginator.firstPage());
    }
  }

  getAllUsers(): void {
    this._homeService.getAllUsers().subscribe({
      next: (data: any[]) => {
        this.allUsers = data
          .filter((user: any) => String(user.type) === '2')
          .reverse();
      },
      error: (error) => console.error(error)
    });
  }

  openUsersFilter(): void {
    this.showAllUsers = true;
  }

  close(): void {
    this.showAllUsers = false;
  }

  selectUser(id: string): void {
    this.page = 1;
    this.selectedUserId = id;
    this.getUserPayment(id, 1, true);
  }

  clearUserFilter(): void {
    this.showAllUsers = false;
    this.page = 1;
    this.selectedUserId = null;

    if (this.isAdmin || this.isSubAdmin) {
      this.getAllPaymentsData(this.perPage, 1, true);
    } else if (this.userId) {
      this.selectedUserId = this.userId;
      this.getUserPayment(this.userId, 1, true);
    }
  }

  onPaginateChange(event: PageEvent): void {
    const newPage = event.pageIndex + 1;

    if (this.selectedUserId) {
      this.getUserPayment(this.selectedUserId, newPage);
      return;
    }

    if (this.isAdmin || this.isSubAdmin) {
      this.getAllPaymentsData(this.perPage, newPage);
      return;
    }

    if (this.userId) {
      this.getUserPayment(this.userId, newPage);
    }
  }

  paymentCompleted(id: any, due: any, userLastName: any): void {
    this.contentReady = true;

    this._FinancialManager.complated(id).subscribe({
      next: () => {
        this.addEx(userLastName, due);
        this.reloadCurrentPage();
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });
  }

  addEx(userLastName: any, total: any): void {
    const bonusPayload = {
      warehouse_id: localStorage.getItem('posId'),
      employee_id: this.userId,
      username: localStorage.getItem('username'),
      amount: total,
      note: userLastName,
      type: '0'
    };

    this._FinancialManager.addexpenses(bonusPayload).subscribe({
      next: () => {},
      error: (error) => console.error(error)
    });
  }

  reloadCurrentPage(): void {
    if (this.selectedUserId) {
      this.getUserPayment(this.selectedUserId, this.page);
      return;
    }

    if (this.isAdmin || this.isSubAdmin) {
      this.getAllPaymentsData(this.perPage, this.page);
      return;
    }

    if (this.userId) {
      this.getUserPayment(this.userId, this.page);
    }
  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel(
      'afiliationpaymenttable',
      'afiliationpayment',
      []
    );
  }

  isRequested(element: any): boolean {
    return element?.requested === 1 || element?.requested === true || element?.requested === '1';
  }

  isCompleted(element: any): boolean {
    return element?.complated === 1 || element?.complated === true || element?.complated === '1';
  }

  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2);

    return `${day}-${month}-${year}`;
  }
}